import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

export default function SuperAdminSidebar() {
    const navigate = useNavigate();
    const location = useLocation();
    const [collapseSidebar, setCollapseSidebar] = useState(false);
    const [selectedItem, setSelectedItem] = useState("");
    const [activeMenus, setActiveMenus] = useState({
        master: false,
        mappingMaster: false
    });

    useEffect(() => {
        // Get the last selected item from URL path
        const currentPath = location.pathname.replace("/", "") || "SuperAdminDashboard";
        setSelectedItem(currentPath);

        // Determine which menus should be open based on the current path
        const masterSubItems = [
            "RoleMaster", "UserMaster",
            "SchoolMaster", "ClassMaster", "Banner", "Badges"
        ];
        const CoursemasterSubItems = [
            "CourseMastercreation", "CourseDetails", 
            "CourseSubdetails","CourseSubcription" ,"AssignmentMaster", "AssignmentQuestion", 
            "ProjectMaster"
        ];
        const QuizmasterSubItems = [
            "QuizMaster", "QuizQuestion"
        ];
        const mappingMasterSubItems = [
            "CourseMapping","TeacherClassMapping"
        ];
        const SSPISubItems = [
            "SspiMaster","SspiQuestion","SchoolSuccessFactor"
        ];
        setActiveMenus({
            master: masterSubItems.includes(currentPath),
            Course: CoursemasterSubItems.includes(currentPath),
            Quiz: QuizmasterSubItems.includes(currentPath),
            mappingMaster: mappingMasterSubItems.includes(currentPath),
            SSPI: SSPISubItems.includes(currentPath)
        });
    }, [location.pathname]);

    const toggleSidebar = () => {
        setCollapseSidebar(!collapseSidebar);
    };

    const onClick = (rt) => {
        setSelectedItem(rt);
        localStorage.setItem("selectedMenuItem", rt);
        navigate(`/${rt}`, { state: {} });
    };

    const toggleMenu = (menu) => {
        setActiveMenus(prev => ({
            ...prev,
            [menu]: !prev[menu]
        }));
    };

    return (
        <div className={`sidebar-container ${collapseSidebar ? "collapsed" : ""}`}>
            <nav className={`sidebar sidebar-offcanvas ${collapseSidebar ? "collapsed" : ""}`} id="sidebar">
                <ul className="nav">
                    <li className="nav-item">
                        <a 
                            className={`nav-link ${selectedItem === "SuperAdminDashboard" ? "active-menu-item" : ""}`} 
                            onClick={() => onClick("SuperAdminDashboard")}
                        >
                            <i className="icon-grid menu-icon"></i>
                            <span className="menu-title">Dashboard</span>
                        </a>
                    </li>

                    {/* Master Menu */}
                    <li className="nav-item">
                        <a 
                            className="nav-link" 
                            onClick={() => toggleMenu("master")} 
                            aria-expanded={activeMenus.master}
                        >
                            <i className="icon-head menu-icon"></i>
                            <span className="menu-title">Master</span>
                            <i className={`menu-arrow ${activeMenus.master ? "rotated" : ""}`}></i>
                        </a>
                        <div className={`collapse ${activeMenus.master ? "show" : ""}`} id="master">
                            <ul className="nav flex-column sub-menu">
                                {[
                                    { key: "RoleMaster", label: "Role Master" },
                                    { key: "UserMaster", label: "User Master" },
                                    { key: "SchoolMaster", label: "School Master" },
                                    { key: "ClassMaster", label: "Class Master" },
                                    { key: "Banner", label: "Banner Master" },
                                    { key: "Badges", label: "Badge Master" }
                                ].map((item) => (
                                    <li className="nav-item" key={item.key}>
                                        <a
                                            className={`nav-link ${selectedItem === item.key ? "active-menu-item" : ""}`}
                                            onClick={() => onClick(item.key)}
                                        >
                                            {item.label}
                                        </a>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </li>
                    <li className="nav-item">
                        <a 
                            className="nav-link" 
                            onClick={() => toggleMenu("Course")} 
                            aria-expanded={activeMenus.Course}
                        >
                            <i class="fa-solid fa-book m-2"></i>
                            <span className="menu-title">Course Master</span>
                            <i className={`menu-arrow ${activeMenus.Course ? "rotated" : ""}`}></i>
                        </a>
                        <div className={`collapse ${activeMenus.Course ? "show" : ""}`} id="Course">
                            <ul className="nav flex-column sub-menu">
                                {[
                                    { key: "CourseMastercreation", label: "Course Master" },
                                    { key: "CourseSubdetails", label: "Course Sub Details" },
                                    { key: "CourseDetails", label: "Course Content" },
                                    { key: "CourseSubcription", label: "Course Subcription" },
                                    { key: "AssignmentMaster", label: "Assignment" },
                                    { key: "AssignmentQuestion", label: "Assignment Questions" },
                                    { key: "ProjectMaster", label: "Project Master" },
                                ].map((item) => (
                                    <li className="nav-item" key={item.key}>
                                        <a
                                            className={`nav-link ${selectedItem === item.key ? "active-menu-item" : ""}`}
                                            onClick={() => onClick(item.key)}
                                        >
                                            {item.label}
                                        </a>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </li>
                    <li className="nav-item">
                        <a 
                            className="nav-link" 
                            onClick={() => toggleMenu("Quiz")} 
                            aria-expanded={activeMenus.Quiz}
                        >
                            <i class="fa-solid fa-gauge-high m-2"></i>
                            <span className="menu-title">Quiz Master</span>
                            <i className={`menu-arrow ${activeMenus.Quiz ? "rotated" : ""}`}></i>
                        </a>
                        <div className={`collapse ${activeMenus.Quiz ? "show" : ""}`} id="Quiz">
                            <ul className="nav flex-column sub-menu">
                                {[
                                    
                                    { key: "QuizMaster", label: "Quiz Master" },
                                    { key: "QuizQuestion", label: "Quiz Question" },
                
                                ].map((item) => (
                                    <li className="nav-item" key={item.key}>
                                        <a
                                            className={`nav-link ${selectedItem === item.key ? "active-menu-item" : ""}`}
                                            onClick={() => onClick(item.key)}
                                        >
                                            {item.label}
                                        </a>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </li>
                    {/* Mapping Master Menu */}
                    <li className="nav-item">
                        <a 
                            className="nav-link" 
                            onClick={() => toggleMenu("mappingMaster")} 
                            aria-expanded={activeMenus.mappingMaster}
                        >
                           <i class="fa-solid fa-link m-2"></i>
                            <span className="menu-title">Mapping Master</span>
                            <i className={`menu-arrow ${activeMenus.mappingMaster ? "rotated" : ""}`}></i>
                        </a>
                        <div className={`collapse ${activeMenus.mappingMaster ? "show" : ""}`} id="mappingMaster">
                            <ul className="nav flex-column sub-menu">
                                {[
                                    { key: "CourseMapping", label: "Course Mapping" },
                                    { key: "TeacherClassMapping", label: "Teacher Class Mapping" },
                                ].map((item) => (
                                    <li className="nav-item" key={item.key}>
                                        <a
                                            className={`nav-link ${selectedItem === item.key ? "active-menu-item" : ""}`}
                                            onClick={() => onClick(item.key)}
                                        >
                                            {item.label}
                                        </a>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </li>
                    <li className="nav-item">
                        <a 
                            className="nav-link" 
                            onClick={() => toggleMenu("SSPI")} 
                            aria-expanded={activeMenus.SSPI}
                        >
                           <i class="fa fa-graduation-cap m-2" aria-hidden="true"></i>
                            <span className="menu-title">SSPI</span>
                            <i className={`menu-arrow ${activeMenus.SSPI ? "rotated" : ""}`}></i>
                        </a>
                        <div className={`collapse ${activeMenus.SSPI ? "show" : ""}`} id="SSPI">
                            <ul className="nav flex-column sub-menu">
                                {[
                                    { key: "SspiMaster", label: "SSPI Master" },
                                    { key: "SspiQuestion", label: "SSPI Question" },
                                    { key: "SchoolSuccessFactor", label: "School Success Factor" },
                                ].map((item) => (
                                    <li className="nav-item" key={item.key}>
                                        <a
                                            className={`nav-link ${selectedItem === item.key ? "active-menu-item" : ""}`}
                                            onClick={() => onClick(item.key)}
                                        >
                                            {item.label}
                                        </a>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </li>
                    <li className="nav-item">
                        <a 
                            className={`nav-link ${selectedItem === "Profile" ? "active-menu-item" : ""}`} 
                            onClick={() => onClick("Profile")}
                        >
                            <i className="icon-paper menu-icon"></i>
                            <span className="menu-title">Profile</span>
                        </a>
                    </li>
                </ul>
            </nav>

            <style>
                {`
                .sidebar-container {
                    position: relative;
                    display: flex;
                }

                .sidebar {
                    width: 250px;
                    transition: width 0.3s ease-in-out;
                }

                .sidebar.collapsed {
                    width: 60px;
                }

                .collapsed .menu-title,
                .collapsed .menu-arrow {
                    display: none;
                }

                .collapsed .nav-link {
                    text-align: center;
                }

                .active-menu-item {
                    text-decoration: underline;
                    font-weight: bold;
                    color: #007bff;
                }

                .collapse {
                    display: none;
                }

                .collapse.show {
                    display: block;
                }

                .menu-arrow {
                    transition: transform 0.3s ease-in-out;
                }

                .menu-arrow.rotated {
                    transform: rotate(90deg);
                }

                .sub-menu {
                    padding-left: 20px;
                }

                .nav-link {
                    cursor: pointer;
                    padding: 10px 15px;
                    display: flex;
                    align-items: center;
                }

                .menu-icon {
                    margin-right: 10px;
                }
                `}
            </style>
        </div>
    );
}